import styled from 'styled-components';

export const UsefulLinksListDefaultBox = styled.ul`
    background-color: ${props => props.theme.colors.background};
    list-style-type: none;
    text-align: left;
    margin: -2px 0;
    padding: 0 1rem 0 1.85rem;
    width: 100%;
`;
